module.exports = __webpack_public_path__ + "static/img/far3_active.3582cb7b.jpg";